module.exports = __webpack_public_path__ + "img/hk.4f92a50b.png";